import {
    Form,
    Input,
    Row,
    Col,
    Switch,
    InputNumber,
    Select,
    DatePicker
} from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';

const EditComponent = (props: any) => {
    const apiId = 'device';
    const { defaultService, editMode } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();

    const [deviceModelData, setDeviceModelData] = useState<any>();
    const [firmwareData, setFirmwareData] = useState<any>();
    const [deviceStatusData, setDeviceStatusData] = useState<any>();
    const [protocolModeData, setProtocolModeData] = useState<any>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        });
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'deviceModel',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setDeviceModelData(res.data);
            }
        });
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'firmware',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setFirmwareData(res.data);
            }
        });
        fetchApi.GET(getService('bm'), {
            query: {
                apiId: 'generalData',
                apiVariable: 'deviceStatus@protocolMode',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { deviceStatus, protocolMode } = res.data;
                setDeviceStatusData(deviceStatus);
                setProtocolModeData(protocolMode);
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        displayOptions: {
            width: 900
        },
        dateOptions: {
            columnNames: ['lastOnlineAt', 'lastHeartbeatAt', 'activatedAt']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="ID"
                            name="id"
                            tooltip="设备的唯一标识，手动/自动生成，通常仅用于系统内部关联与追溯。">
                            <Input disabled={editMode === 'NEW' ? false : true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="设备名称"
                            name="deviceName"
                            tooltip="设备的展示名称，用于在列表、地图、告警等界面中识别该设备，建议填写便于人工辨认的名称，如：客厅音箱、机房温控01。"
                            rules={[{ required: true, message: '设备名称!' }]}>
                            <Input placeholder="如：客厅音箱、机房温控01" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="设备型号"
                            name="deviceModelId"
                            tooltip="该设备对应的型号，来源于“设备型号”字典。型号决定了设备的主控芯片、固件、通信协议等基础能力，修改会影响后续固件匹配与协议解析。">
                            <Select
                                allowClear
                                placeholder="请选择设备型号"
                                showSearch={{ optionFilterProp: 'label' }}
                                options={getList.general2(deviceModelData, { itemName: 'modelName' })}>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="硬件版本"
                            name="hardwareVersion"
                            tooltip="设备硬件的版本号，用于区分同一型号下不同批次的硬件差异，便于固件适配与问题排查，如：HW-1.0 / V2.3。">
                            <Input placeholder="如：HW-1.0 / V2.3" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="序列号"
                            name="serialNumber"
                            tooltip="设备的唯一序列号（SN），用于设备身份识别、激活绑定与售后溯源，必须全局唯一，通常由厂商或平台统一生成，如：MF-0001-XXXX。"
                            rules={[{ required: true, message: '设备序列号（唯一）!' }]}>
                            <Input placeholder="如：MF-0001-XXXX" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="MAC地址"
                            name="macAddress"
                            tooltip="设备的唯一网卡物理地址，用于局域网内设备识别与配网绑定。格式如：AA:BB:CC:DD:EE:FF，可留空（如为纯蓝牙设备或无网卡设备）。">
                            <Input placeholder="如：AA:BB:CC:DD:EE:FF" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="客户端id"
                            name="clientId"
                            tooltip="MQTT上的唯一客户端id，可留空。">
                            <Input placeholder="如：AA:BB:CC:DD:EE:FF" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="IP地址"
                            name="ipAddress"
                            tooltip="设备当前或最近一次在局域网/公网中的 IP 地址，用于远程访问与网络排查。通常由平台在设备上线时自动上报，可手动修正。">
                            <Input placeholder="如：192.168.1.100" />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="协议"
                            name="protocolModeId"
                            tooltip="设备与平台通信所使用的协议模式（如 MQTT、HTTP、WebSocket 等），来源于“通信协议”字典。用于决定平台侧如何解析与下发数据。">
                            <Select
                                allowClear
                                placeholder="通信协议"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(protocolModeData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="故障码"
                            name="faultCode"
                            tooltip="设备最近一次上报的故障代码，用于快速定位故障类型，具体含义需参照设备协议或型号文档，如：E001。">
                            <Input placeholder="如：E001" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="设备状态"
                            name="deviceStatusId"
                            tooltip="设备当前的运行状态（如在线、离线、故障、休眠等），来源于“设备状态”字典。通常由平台根据心跳、上报自动更新，也可手动修正。">
                            <Select
                                allowClear
                                placeholder="设备状态"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(deviceStatusData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="故障信息"
                            name="faultMessage"
                            tooltip="设备最近一次上报的故障详细描述，可包含故障原因、位置、建议处理方式等，便于运维人员快速定位与处理。">
                            <Input.TextArea
                                rows={2}
                                placeholder="故障描述信息..."
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="当前固件"
                            name="currentFirmwareId"
                            tooltip="设备当前运行的固件版本，来源于“固件”字典。用于判断是否需要 OTA 升级，以及升级/回滚时选择目标固件。">
                            <Select
                                allowClear
                                placeholder="请选择当前固件"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(firmwareData, { itemName: 'version' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="安装位置"
                            name="location"
                            tooltip="设备的实际安装位置，用于地图展示、按区域筛选与运维定位，建议填写楼栋-楼层-房间等结构清晰的描述，如：1号楼3层机房。">
                            <Input placeholder="如：1号楼3层机房" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="经纬度"
                            name="coordinates"
                            tooltip="设备的经纬度坐标，使用 JSON 格式填写，如：{&quot;lat&quot;:23.1,&quot;lng&quot;:113.2}。用于地图打点展示与地理围栏判断，可留空。">
                            <Input.TextArea
                                rows={2}
                                placeholder='{"lat":23.1,"lng":113.2}'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="扩展配置"
                            name="config"
                            tooltip="设备的扩展配置项，使用 JSON 格式填写，如：{&quot;volume&quot;:80,&quot;threshold&quot;:30}。用于存储设备个性化的运行参数，平台不解析具体字段，仅原样保存与下发。">
                            <Input.TextArea
                                rows={2}
                                placeholder='{"volume":80,"threshold":30}'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="最后心跳"
                            name="lastHeartbeatAt"
                            tooltip="设备最后一次发送心跳包的时间，由平台根据设备心跳自动更新。用于判断设备在线状态及离线超时，通常不需要手动修改。">
                            <DatePicker
                                showTime
                                style={{ width: '100%' }}
                                placeholder="请选择最后心跳时间"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="最后在线"
                            name="lastOnlineAt"
                            tooltip="设备最后一次与平台成功建立连接的时间，由平台根据设备连接/上报自动更新，通常不需要手动修改。">
                            <DatePicker
                                showTime
                                style={{ width: '100%' }}
                                placeholder="请选择最后在线时间"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="离线原因"
                            name="offlineReason"
                            tooltip="设备离线原因。">
                            <Input placeholder="离线原因（可空）" />
                        </Form.Item>
                    </Col>

                    <Col span={9}>
                        <Form.Item
                            label="用户id"
                            name="userId"
                            tooltip="设备登录时所用的用户id，可留空。">
                            <Input placeholder="用户id（可空）" />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="拥有人"
                            name="unionId"
                            tooltip="设备所属用户的微信 unionId，用于将设备与用户账号绑定（如小程序/公众号场景）。若设备暂未归属任何用户，可留空。">
                            <Input placeholder="微信用户 unionId（可空）" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="排序"
                            name="sort"
                            tooltip="列表展示时的排序权重，数值越小越靠前。用于调整设备在列表/地图中的显示顺序，默认 0。">
                            <InputNumber
                                style={{ width: 90 }} />
                        </Form.Item>
                    </Col>

                    <Col span={9}>
                        <Form.Item
                            label="激活时间"
                            name="activatedAt"
                            tooltip="设备首次完成激活（绑定到平台并生成 token）的时间，由平台在激活时自动写入，通常不需要手动修改。">
                            <DatePicker
                                showTime
                                style={{ width: '100%' }}
                                placeholder="请选择激活时间"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={11}>
                        <Form.Item
                            label="token"
                            name="token"
                            tooltip="设备的访问令牌，用于设备与平台之间的身份校验。首次激活或重新配网时生成/更新，泄露后需及时重置，避免被冒用。">
                            <Input placeholder="设备token" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}
                            tooltip="设备是否启用。启用后设备可正常连接与上报；关闭后平台不再处理该设备的连接与数据，可用于临时停用或下线设备。">
                            <Switch
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="备注"
                            name="memo"
                            tooltip="设备的补充备注信息，可填写安装说明、维护记录、特殊使用说明等，仅用于人工查看，不影响设备运行。">
                            <Input.TextArea
                                rows={3}
                                placeholder="设备备注信息..."
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />);
};

export default EditComponent;